import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import type EnterCardFormStoreType from 'bundles/account-settings/stores/EnterCardFormStore';
import type {
  PropsFromCaller,
  PropsToComponent,
} from 'bundles/payments-common/components/inputs/BraintreeHostedFieldFormGroup';
import { BraintreeHostedFieldFormGroup } from 'bundles/payments-common/components/inputs/BraintreeHostedFieldFormGroup';

type Stores = {
  EnterCardFormStore: typeof EnterCardFormStoreType;
};

export default connectToStores<PropsToComponent, PropsFromCaller, Stores>(
  ['EnterCardFormStore'],
  ({ EnterCardFormStore }) => {
    return {
      braintreeHostedFields: EnterCardFormStore.getBraintreeHostedFields(),
      onStatusChange: () => EnterCardFormStore.emitChange(),
    };
  }
)(BraintreeHostedFieldFormGroup);
